
import React from 'react';
import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';

interface SubmitButtonProps {
  isSubmitting: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ isSubmitting }) => {
  return (
    <Button 
      type="submit" 
      className="w-full h-11 bg-gradient-to-r from-blue-400 via-blue-600 to-purple-500 text-white font-medium rounded-full shadow-md"
      disabled={isSubmitting}
    >
      {isSubmitting ? (
        <>
          <Icon name="Loader2" className="mr-2 animate-spin" size={18} />
          Creating Account...
        </>
      ) : (
        <>
          Create Account
          <Icon name="ArrowRight" className="ml-2" size={18} />
        </>
      )}
    </Button>
  );
};

export default SubmitButton;
